import { Dropdown } from 'primereact/dropdown'
import { InputText } from 'primereact/inputtext'
import React, { useEffect, useState } from 'react'
import { UbicacionesService } from '../../services/Ubicaciones/UbicacionesService';
import { ubicacionesDeViaje } from '../../services/Ubicaciones/ubicacionesDeViaje';

let _ubicacion = {
    ubicacionId: null,
    nombre: '',
    nombreTmp: '',
    codigo: '',
    latitud: '',
    longitud: '',
    area: '',
    estado: 'Activo',
    activo: true,
    tipoUbicacion: {
        nombre: '',
    },
    ubicacionInfoList: [
    ],
    ubicacionTarjetaList: [

    ]


}

const Ruta = () => {



    const [selectedCity, setSelectedCity] = useState(null);
    const [ubicacionesOrigen, setUbicacionesOrigen] = useState([]);
    const [ubicacionesDestino, setUbicacionesDestino] = useState([]);

    const ubicacionesService = new UbicacionesService();

    useEffect(() => { ubicacionesService.getListaUbicaciones().then(data => {
        

         let _ubicacionList = [];
         ubicacionesDeViaje(data).forEach(d => {

            let _ubicacionTmp = { ..._ubicacion };
            _ubicacionTmp.nombreTmp = (d.codigo + "-" + d.nombre);
            _ubicacionTmp.nombre = d.nombre;
            _ubicacionTmp.codigo = d.codigo;

            _ubicacionList.push(_ubicacionTmp);
           
         });

         setUbicacionesOrigen(_ubicacionList);
         setUbicacionesDestino(_ubicacionList);
        
        
        
        }) }, []);

   



    return (
        <div className="card p-fluid">

            <div className="formgrid grid">

                <div className="field col-6 md:col-6 lg:col-6 sm:col-6">
                    <label htmlFor="codigo">Código</label>
                    <InputText type="text" style={{ opacity: 1 }} />
                </div>
                <div className="field col-6 md:col-6 lg:col-6 sm:col-6">
                    <label htmlFor="nombre">Nombre</label>
                    <InputText type="text" style={{ opacity: 1 }} />
                </div>

                <div className="field col-6">
                    <label htmlFor="origenPunto">Origen Punto</label>
                    <Dropdown  options={ubicacionesOrigen} optionLabel="nombreTmp" placeholder="Origen" className="w-full " />
                </div>

                <div className="field col-6">
                    <label htmlFor="destinoPunto">Destino Punto</label>
                    <Dropdown placeholder="Destino" options={ubicacionesDestino} optionLabel="nombreTmp" className="w-full " />
                </div>


            </div>
        </div>
    )
}

export default Ruta